export default function Intro() {
  return (
    <section className="flex-col md:flex-row flex items-center md:justify-center mt-6 mb-12">
      <h1 className="text-center lg:text-2xl md:text-lg text-[17px] font-bold mb-6 text-[#ff9245] capitalize">
      NEET support blogs — NEET  news and updates
            <hr className="border-t-2 border-black mx-auto  w-full max-w-[400px] lg:max-w-[530px] md:max-w-[500px]" />
          </h1>
    </section>
  );
}
